<h1 mat-dialog-title>No tan rápido vaquero 🤠</h1>
<mat-dialog-content>
  Antes de irte, debes fichar el trabajo que has hecho.
  <br />
  Si no lo haces, no lo recordarás.
  <mat-dialog-actions align="end">
    <button mat-flat-button (click)="close()" color="accent">¡Voy!</button>
  </mat-dialog-actions>
</mat-dialog-content>
